<template>
    <div class="">
        <Header></Header>
        <div class="page-container">
            <div class="page-wrapper">



                <div class="page-content-container">
                    <div class="page-content-header">
                        <div class="page-header-block"></div>
                        <div class="other-plan-btn" @click="viewOtherPlan" v-if="showOtherPlans">其他计划</div>
                        <template v-for="(item, key) in navList">
                            <div :key="key" @click="handleNav(item.id)"
                                :class="activeNav == item.id ? 'page-content-header-item-active' : 'page-content-header-item'"
                                v-if="item.show">
                                {{ item.label }}
                                <div v-if="activeNav == item.id" class="nav-line-wrapper">
                                    <div class="nav-line"></div>
                                </div>
                            </div>

                        </template>
                    </div>
                    <div class="page-content-wrapper">
                        <div class="page-content">
                            <div v-if="activeNav == 'manage-plan'">
                                <ManagePlan></ManagePlan>
                            </div>
                            <div v-if="activeNav == 'my-plan'">
                                <MyPlan></MyPlan>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import ManagePlan from './components/ManagePlan.vue'
import MyPlan from './components/MyPlan.vue'
export default {
    name: '',
    components: {
        Header,
        ManagePlan,
        MyPlan
    },
    data() {
        return {
            dept: '',
            token: '',
            navList: [
                {
                    id: 'manage-plan',
                    label: '管理计划',
                    show: true,
                },
                {
                    id: 'my-plan',
                    label: '我的计划',
                    show: true,
                }
            ],
            activeNav: localStorage.getItem('handleNav') ? localStorage.getItem('handleNav') : 'manage-plan',
            userInfo: {},
            showOtherPlans: true,
        }
    },
    mounted() {
        scrollTo(0, 0);

        this.dept = window.localStorage.getItem('dept');
        this.token = window.localStorage.getItem('token');
        // this.activeNav = this.$route.params.mode;
        this.userInfo = JSON.parse(window.localStorage.getItem('user'));
        if (this.userInfo && this.userInfo.role === 0) {
            this.showOtherPlans = false
            this.navList.forEach(item => {
                if (item.id === 'manage-plan') {
                    item.show = false
                    this.activeNav = 'my-plan'
                    localStorage.setItem('handleNav', 'my-plan')
                }
            });
        }

    },
    methods: {
        handleBack() {
            this.$router.go(-1);
            //  this.$router.push(`/index/enterprise-center/${this.dept}/${this.token}`);
        },
        handleNav(target) {
            this.activeNav = target;
            localStorage.setItem('handleNav', target)
            // this.$router.push(`/studyPlan/${target}`);
        },
        viewOtherPlan() {
            this.$router.push(`/managePlan/otherPlan`);
        }
    }
}
</script>

<style scoped>
.page-container {
    margin-top: 20px;
    width: 100%;

}

.page-wrapper {
    height: 800px;
    overflow: hidden;
    width: 1200px;
    margin: 0 auto;

}

.page-back-wrapper {
    width: 100%;
    height: 68px;
    background: #ffffff;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #f0f0f3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 18px;
}

.page-back-img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    display: inline-block;
    position: relative;
    top: 2px;
}

.page-back {
    display: flex;
    align-items: center;
    margin-left: 30px;
    cursor: pointer;
}

.nav-line-wrapper {
    width: 100%;
    bottom: 15px;
    left: 0px;
    position: absolute;
    display: flex;
    justify-content: center;
    margin-top: 6px;
}

.nav-line {
    width: 22px;
    height: 6px;
    background: #4F79ED;
    border-radius: 3px;
}

.page-content-container {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #F0F0F3;
    /* margin-top: 18px; */
}

.page-content-header {
    width: 100%;
    height: 80px;
    border-radius: 6px 5px 0px 0px;
    line-height: 80px;
    position: relative;
    display: flex;
}

.page-header-block {
    position: relative;
    width: 6px;
    height: 24px;
    background: #4F79ED;
    border-radius: 0px 17px 17px 0px;
    position: absolute;
    left: 0px;
    top: 28px;
}

.page-content-header-item {
    width: 170px;
    height: 100%;
    text-align: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #848F9A;
    position: relative;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.page-content-header-item:hover {
    color: #4F79ED;
    cursor: pointer;
}

.page-content-header-item-active {
    width: 170px;
    height: 100%;
    text-align: center;
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3E63EE;
    cursor: pointer;
    position: relative;
}

.page-content-wrapper {
    height: 700px;
    /* overflow: hidden; */
    overflow-y: auto;
    /* display: flex; */
}

.page-content {
    flex: 1;
    margin: 30px 41px 30px 45px;
}

.other-plan-btn {
    position: absolute;
    right: 0;
    top: 20px;
    width: 108px;
    height: 36px;
    border-radius: 6px;
    border: 1px solid #FF9645;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FF9645;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 40px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.other-plan-btn:hover {
    cursor: pointer;
    background: #FF9645;
    color: #fff;
}
</style>


